import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { orderApi } from '@/api/endpoints';
import Pagination from '@/components/common/Pagination';
import { Empty, ErrorState, Loading } from '@/components/common/State';
import { ORDER_STATUS_LABEL, ORDER_STATUS_TONE, formatDate, formatWon } from '@/utils/format';

export default function OrderListPage() {
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['orders', page, status],
    queryFn: () => orderApi.list({ page, size: 10, status: status || undefined }),
  });

  return (
    <>
      <h1 className="panel-title">주문 내역</h1>

      <select
        className="select"
        style={{ maxWidth: 200, marginBottom: 20 }}
        value={status}
        onChange={(e) => {
          setStatus(e.target.value);
          setPage(1);
        }}
      >
        <option value="">전체 상태</option>
        {Object.entries(ORDER_STATUS_LABEL).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>

      {isLoading && <Loading />}
      {isError && <ErrorState error={error} onRetry={refetch} />}

      {data &&
        (data.content.length === 0 ? (
          <Empty title="주문 내역이 없습니다.">
            <Link to="/products" className="btn btn--primary btn--sm">
              상품 둘러보기
            </Link>
          </Empty>
        ) : (
          <>
            {data.content.map((order) => (
              <Link to={`/orders/${order.orderId}`} className="line-item" key={order.orderId}>
                <img src={order.thumbnailUrl} alt="" />
                <div className="line-item__body">
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span className={`badge badge--${ORDER_STATUS_TONE[order.status]}`}>
                      {ORDER_STATUS_LABEL[order.status]}
                    </span>
                    <span className="muted">{formatDate(order.orderedAt, true)}</span>
                  </div>
                  <p style={{ fontWeight: 600, margin: '8px 0 4px' }}>{order.orderName}</p>
                  <p className="muted" style={{ margin: 0, fontSize: 13 }}>
                    주문번호 {order.orderNo} · 상품 {order.itemCount}건
                  </p>
                  <strong>{formatWon(order.paymentAmount)}</strong>
                </div>
              </Link>
            ))}
            <Pagination page={data.page} totalPages={data.totalPages} onChange={setPage} />
          </>
        ))}
    </>
  );
}
